var exports = {
  "M": "VoiceSceneTv.module__bar___bXBuen",
};

module.exports = exports;
